export default {
    cheatsheet: {
        title: "Hoja de apuestas",
        empty: {
            noPlaysAvailable: "No hay jugadas disponibles",
        },
        separators: {
            noLongerPerfect: "Ya no es 100% debajo de esto",
        },
        generate: {
            homeRow: "Generar tu hoja de apuestas",
            results: {
                title: "Tu cheatsheet",
                subtitle: "Generada",
            },
            actions: {
                generate: "Generar",
            },
            options: {
                all: "Todo",
            },
            empty: {
                title: "No se encontraron props",
                subtitle: "Prueba cambiar tus selecciones para encontrar más props.",
                action: "Ajustar selecciones",
            },
            outcome: {
                title: "¿Qué estás buscando?",
                subtitle: "Elige Más o Menos.",
                over: "Más",
                under: "Menos",
            },
            propType: {
                title: "¿Qué prefieres?",
                subtitle: "Elige props de jugador o equipo.",
                player: "Props de jugador",
                team: "Props de equipo",
            },
            lineType: {
                title: "¿Qué líneas quieres?",
                subtitle: "Elige principales o alternativas.",
                main: "Líneas principales",
                alternate: "Líneas alternativas",
            },
            cheatsheetType: {
                title: "¿En qué deberíamos basarnos?",
                subtitle: "Elige el periodo para basarlo.",
                recentForm: "Forma reciente",
                versusOpponent: "Contra rival",
                homeAwaySplits: "Local/visitante",
            },
            games: {
                title: "¿Qué partidos incluir?",
                subtitle: "Incluye todos los partidos o elige los que quieras.",
            },
            betTypes: {
                title: "¿Qué props quieres?",
                subtitle: "Elige los tipos de apuesta que quieres incluir.",
            },
            operators: {
                title: "¿Dónde deberíamos buscar?",
                subtitle: "Elige las cuotas que quieres incluir.",
            },
            loader: {
                prefix: "Buscando",
                ready: "Hoja lista",
                accessibilityLabel: "Generando tu hoja de apuestas",
                values: {
                    overs: "Más...",
                    unders: "Menos...",
                    mainLines: "Líneas principales...",
                    alternateLines: "Líneas alternativas...",
                    recentForm: "Forma reciente...",
                    versusOpponent: "Contra rival...",
                    homeAwaySplits: "Local/visitante...",
                    todaysGames: "Partidos de hoy...",
                    selectedGames: "{{count}} partido(s) seleccionado(s)...",
                    allBetTypes: "Todos los tipos de apuesta...",
                    oneBetType: "{{name}}...",
                    twoBetTypes: "{{first}} y {{second}}...",
                    manyBetTypes: "{{count}} tipos de apuesta...",
                    yourSportsbooks: "Tus casas de apuesta...",
                    allSportsbooks: "Todas las casas de apuesta...",
                    specificSportsbooks: "{{count}} casa(s) de apuesta...",
                    building: "Creando tu cheatsheet...",
                },
            },
        },
    },
};
